<template>
	<section>
		<div class="container">
			<slot />
		</div>
	</section>
</template>

<script>
export default {
	name: "RolesSection",
};
</script>

<style lang="scss" scoped>
section {
	padding: 8rem 0 12rem 0;
	background: linear-gradient(to bottom, rgba(244, 245, 247, 1), rgba(244, 245, 247, 0));
	border-radius: 2rem;
}
</style>
